/**
 * SOLOMON — MESSAGE SOURCES
 * Live web answers: the numbered Sources list behind [n] citations in a
 * Solomon reply. Glass card per the design system; collapsed to a header
 * row by default so it supports the answer without dominating the bubble.
 */

import { useState } from 'react';

function domainOf(url) {
  try { return new URL(url).hostname.replace(/^www\./, ''); }
  catch { return url; }
}

export default function MessageSources({ sources }) {
  const [open, setOpen] = useState(false);
  if (!Array.isArray(sources) || sources.length === 0) return null;

  return (
    <div className="message-sources">
      <button
        type="button"
        className="message-sources__toggle"
        onClick={() => setOpen(o => !o)}
        aria-expanded={open}
      >
        <span className="message-sources__globe">🌐</span>
        <span>{sources.length} source{sources.length === 1 ? '' : 's'}</span>
        <span className={`message-sources__chevron${open ? ' message-sources__chevron--open' : ''}`}>▾</span>
      </button>

      {open && (
        <ol className="message-sources__list">
          {sources.map((s) => (
            <li key={s.id} className="message-sources__item">
              <span className="message-sources__num">{s.id}</span>
              {s.url ? (
                <a
                  className="message-sources__link"
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  title={s.url}
                >
                  {s.title || s.url}
                </a>
              ) : (
                // Research findings without an upstream URL — plain text entry.
                <span className="message-sources__link" title={s.title}>
                  {s.title}
                </span>
              )}
              <span className="message-sources__domain">{s.url ? domainOf(s.url) : 'saved research'}</span>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
}
